import React, { useState } from "react";
import { Container, Row, Col, Button, Card, Modal, InputGroup, Form, FormControl, Image } from "react-bootstrap";
import Countdown from "react-countdown";
import RangeSlider from "react-bootstrap-range-slider";


import VotonCrowd from "../../assets/logos/Logo_White_SVG.svg";
import Mark from "../../assets/logos/warning.png";
import VotonLogo from "../../assets/logos/V/Logo_V_White.png";
import Path from "../../assets/logos/path.png";

import styles from "./TokenPreSale.module.css";

const Completionist = () => <span> You are good to go</span>;
const date15M = new Date("2022-04-29 23:59:59");

function WalletAddressdModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <h4 className={styles.modelaWalletAddress}>Wallet Address</h4>
        <p>
          In order to receive your Voton Tokens, please select your ERC 20
          wallet address that has an ability to add custom tokens or else use
          MetaMask Wallet for receiving tokens. You will receive Voton tokens to
          this address after the Token Sale ends.
        </p>
        <Form.Label htmlFor="basic-url" className={styles.ModalAddressTitle}>
          Your Ethereum (ERC-20) Address for Token
        </Form.Label>
        <InputGroup className="mb-3">
          <FormControl
            id="basic-url"
            aria-describedby="basic-addon3"
            placeholder="Paste your address here"
          />
        </InputGroup>
        <p className={styles.NoteAddress}>
          Note: Address should be ERC20-Complaint
        </p>
        <p>
          DO NOT USE your exchange wallet address such as Kraken, Bitfinex,
          Bithumb, Binance etc. You can use MetaMask, MayEtherWallet, Mist
          wallets etc. Do not use the address if you don’t have a private key of
          the your address. You WILL NOT receive Voton Tokens and WILL LOSE YOUR
          FUNDS if you do
        </p>
      </Modal.Body>
      <Button
        variant="default"
        style={{
          color: "white",
          background: "#F10045",
          marginTop: "0.5rem",
          marginLeft: "0.8rem",
          width: "180px",
          borderRadius: "10px",
          boxShadow: "rgba(255, 255, 255, 0.35) 0px 5px 15px !important",
          textShadow: "0 0 15px #fafafa",
          marginBottom: "1.5rem",
          fontFamily: "Montserrat",
          fontWeight: "220",
        }}
        onClick={props.onHide}
      >
        Add Wallet
      </Button>
    </Modal>
  );
}


const currentDate = new Date();
const startDate = new Date("2022-04-29 23:59:59")

function TokenPreSale() {
  const [modalShow, setModalShow] = React.useState(false);
  const [value, setValue] = useState(0);
  return (currentDate < startDate ? <></> : 
    <Container className={styles.ContentContainer}>
      <Row sm={12}>
        <Col sm={6}>
          <h1 className={styles.TokensTitle}>Buy tokens</h1>
          <br></br>
          <h3 className={styles.steponetitle}>STEP - 1</h3>
          <h5 className={styles.Wallettitle}>Please add Wallet address</h5>
          <Button
            className={styles.walletAddressbtn}
            onClick={() => setModalShow(true)}
          >
            <div className={styles.walletAddressbtntext}></div>
            ERC-20 Wallet Address
          </Button>
          <WalletAddressdModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <Row sm={12}>
            <Col sm={12}>
              <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <p className={styles.walletAddress}>
                Add your ERC-20 wallet address to receive tokens. Please choose
                a wallet where you can add custom tokens or alternatively use a
                MetaMask wallet which is preferred.
              </p>
              </div>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Card className={styles.cardToken}>
            <Card.Body>
              <Card.Title className={styles.salestext}>
                Current Token Price
              </Card.Title>
              <Card.Text className={styles.tokentext}>$0.0000025</Card.Text>
              <br></br>
              <Card.Title className={styles.salestext}>
                Total Pre-Sale
              </Card.Title>
              <Row>
                <Col>
                  <Card.Text className={styles.tokentext}>
                    50,000,000,000
                  </Card.Text>
                </Col>
                <Col>
                  <Card.Text className={styles.votontext}>
                    <img
                      src={VotonCrowd}
                      alt="votoncrowd"
                      className={styles.votonLogo}
                    />
                  </Card.Text>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row sm={12}>
        <Col sm={6}>
          <h3 className={styles.steptwotitle}>STEP - 2</h3>
          <h5 className={styles.amountText}>Enter Amount</h5>
          <p className={styles.walletAddress}>
            Enter the amount in the first box that you would like to contribute
            to purchase Voton tokens, click below and in a few seconds you will
            see the amount of tokens that you will receive.
          </p>
          <Row className="mb-3" style={{ textAlign: "left" }}>
            <Form.Group as={Col} md="4">
              <Form.Label className={styles.inputLabel}>
                Total Amount(USD)
              </Form.Label>
              <Form.Control size="lg" required type="text" />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label className={styles.inputLabel}>
                Total Voton you receive
              </Form.Label>
              <Form.Control size="lg" required type="text" />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            <Col sm={12}>
            <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <p className={styles.walletAddress}>
                The price shown here is not final. When the payment is submitted
                on the Payment gateway, the network will be added.
              </p>
              </div>
              <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <p className={styles.walletAddress}>
                Your contribution will be calculated based on current token
                price at the moment your transaction is confirmed.
              </p>
              </div>
              <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <p className={styles.walletAddress}>
                The minimum and the maximum limit for a single transaction is
                between $100 and $50,000
              </p>
              </div>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Card className={styles.presalecardToken}>
            <Card.Body>
              <Card.Title className={styles.presalestext}>
                PRE-SALE PROGRESS
              </Card.Title>
              <Row>
                <Col>
                  <Card.Text className={styles.pretokentext}>
                    Total token&nbsp;&nbsp;<Image src={VotonLogo} width="23px" height="23px" alt="voton logo"/>50,000,000,000
                  </Card.Text>
                </Col>
              </Row>
              <>
                <RangeSlider
                  value={20}
                  variant="warning"
                  onChange={(changeEvent) => setValue(changeEvent.target.value)}
                />
              </>
              <br></br>
              <Card.Title className={styles.presalesendstext}>
                Pre-Sale Ends
                </Card.Title>
                <Countdown
                  date={date15M}
                  renderer={({ days, hours, minutes, seconds, completed }) => {
                    if (completed) {
                      return <div>yayyyyyyyy</div>;
                    } else {
                      return (
                        <div className={styles.timer}>
                          <div className={styles.interval}>
                            <div className={styles.timerCircle}>
                              <div className={styles.timerNumber}>{days}</div>
                            </div>
                            <div className={styles.timerIntervalText}>Days</div>
                          </div>
                          <div
                            className={`${styles.interval} ${styles.timeIntervalSpacer}`}
                          >
                            <div className={styles.timerCircle}>
                              <div className={styles.timerNumber}>{hours}</div>
                            </div>
                            <div className={styles.timerIntervalText}>
                              Hours
                            </div>
                          </div>
                          <div
                            className={`${styles.interval} ${styles.timeIntervalSpacer}`}
                          >
                            <div className={styles.timerCircle}>
                              <div className={styles.timerNumber}>
                                {minutes}
                              </div>
                            </div>
                            <div className={styles.timerIntervalText}>
                              Minutes
                            </div>
                          </div>
                          <div
                            className={`${styles.interval} ${styles.timeIntervalSpacer}`}
                          >
                            <div className={styles.timerCircle}>
                              <div className={styles.timerNumber}>
                                {seconds}
                              </div>
                            </div>
                            <div className={styles.timerIntervalText}>
                              Seconds
                            </div>
                          </div>
                        </div>
                      );
                    }
                  }}
                />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row sm={12}>
        <Col sm={6}>
          <br></br>
          <h3 className={styles.stepthreetitle}>STEP - 3</h3>
          <h5 className={styles.Wallettitle}>Make Payment</h5>
          <p className={styles.walletAddress}>
            To receive Voton tokens please make payment. You will then be
            redirected to the Payment Gateway to make the online payment. Once
            you have paid, you will receive an email to confirm that your
            deposit has been
          </p>
          <Row sm={12}>
          <Col sm={12}>
          <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <h6 className={styles.confirmationMessage}>
                Please allow 24 hours for your Voton tokens to show up in your
                Dashboard.This happens after your transaction is approved
              </h6>
              </div>
          </Col>
          </Row>
          <br/>
          <Button className={styles.paymentbtn}>
            <div className={styles.paymentbtntext}></div>
            Make Online Payment
          </Button>
          <Row>
            <Col sm={12}>
            <div className={styles.questionContainer}>
              <img src={Mark} alt="mark" className={styles.questionMark} />
              <p className={styles.walletAddress}>
                Your Voton tokens will appear in your account after your deposit
                has been received successfully and confirmed by payment gateway.
              </p>
              </div>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Card className={styles.votoncontactaddress}>
            <Card.Body>
              <Card.Title className={styles.salestext}>
                Voton contract address
              </Card.Title>
              <Card.Text className={styles.tokentext}>
                0x4757a461F55......be3Aa09b6871&nbsp;<Image src={Path} width="23px" height="23px" alt="path copy"/>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default TokenPreSale;
